var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearchTagLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1862_170521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66663 13.3332H5.33329L12.3333 6.33321C12.6869 5.97959 12.8856 5.49997 12.8856 4.99988C12.8856 4.49978 12.6869 4.02016 12.3333 3.66654C11.9797 3.31292 11.5001 3.11426 11 3.11426C10.4999 3.11426 10.0202 3.31292 9.66663 3.66654L2.66663 10.6665V13.3332Z",
    stroke: "#EB0000",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4.33398L11.6667 7.00065",
    stroke: "#EB0000",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1862_170521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchTagLog);
export default __webpack_public_path__ + "static/media/icon_search_tag_log.aca9721ca8bae42d49aa2da1e03dd41b.svg";
export { ForwardRef as ReactComponent };